import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: '',
  isLoading: true,
  subscription: {},
  cupon: {},
  highlightedId: null,
  user: {},
  affiliate: {},
  models: {}
};

const DataSlice = createSlice({
  name: 'Data',
  initialState,
  reducers: {
    //subscription
    subscriptionRequest(state, action) {
      state.status = action.type;
    },
    subscriptionSuccess(state, action) {
      state.subscription = action.payload
      state.status = action.type;
    },
    subscriptionFailure(state, action) {
      state.error = action.error;
      state.status = action.type;
    },
    //cupon
    cuponRequest(state, action) {
      state.status = action.type;
    },
    cuponSuccess(state, action) {
      state.cupon = action.payload
      state.status = action.type;
    },
    cuponFailure(state, action) {
      state.error = action.error;
      state.status = action.type;
    },
    //highlightedId
    highlightedIdRequest(state, action) {
      state.status = action.type;
    },
    highlightedIdSuccess(state, action) {
      state.highlightedId = action.payload
      state.status = action.type;
    },
    highlightedIdFailure(state, action) {
      state.error = action.error;
      state.status = action.type;
    },
    resetHighlightedId(state) {
      state.highlightedId = null;
      state.status = 'resetHighlightedId';
    },
    //user
    userRequest(state, action) {
      state.status = action.type;
    },
    userSuccess(state, action) {
      state.user = action.payload
      state.status = action.type;
    },
    userFailure(state, action) {
      state.error = action.error;
      state.status = action.type;
    },

    //affiliate
    affiliateRequest(state, action) {
      state.status = action.type;
    },
    affiliateSuccess(state, action) {
      state.affiliate = action.payload
      state.status = action.type;
    },
    affiliateFailure(state, action) {
      state.error = action.error;
      state.status = action.type;
    },

    //models
    modelsRequest(state, action) {
      state.status = action.type;
    },
    modelsSuccess(state, action) {
      state.models = action.payload
      state.status = action.type;
    },
    modelsFailure(state, action) {
      state.error = action.error;
      state.status = action.type;
    },



  },
});

export const {
  subscriptionFailure,
  subscriptionRequest,
  subscriptionSuccess,
  cuponFailure,
  cuponRequest,
  cuponSuccess,
  highlightedIdSuccess,
  highlightedIdRequest,
  highlightedIdFailure,
  resetHighlightedId,
  userSuccess,
  userRequest,
  userFailure,
  affiliateSuccess,
  affiliateRequest,
  affiliateFailure,
  modelsSuccess,
  modelsRequest,
  modelsFailure

} = DataSlice.actions;

export default DataSlice.reducer;
